export const TOKEN_EXPIRED = '-20012'
export const USER_NOT_FOUND = '-20015'
export const DATE_RANGE_EXCEEDED = '-20031'
export const START_DATE_AFTER_END_DATE = '-20032'
